import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import LifeMartPreview from "@/pages/LifeMartPreview";

// Kept live as of 2026-08-06 while /lifemart itself, its redirect target,
// and a possible /stack URL rename are still under review -- see
// src/config/featureFlags.ts LIFEMART_PUBLIC_PAGES_ENABLED doc comment.
export const Route = createFileRoute("/lifemart/")({
  head: () => seoHead("/lifemart/"),
  component: LifeMartPreview,
});
